import { userState } from '../config/common';
import { googleConfig } from '../config/googleConfig';
export const useAuth = () => {

    const requireAuth = () => {
        var path = window.location.pathname;
        if(path.indexOf('/edit/') === -1) {
            return false;
        }
        return true;
    };

    const initAuth = () => {
        if(requireAuth()) {
            handleGoogleLogin();
        }
    };
    const getParamVal = (key) => {
        const params = new URLSearchParams(window.location.search);
        if(params.has(key)){
            return params.get(key);
        }
        return null;
    };
    const handleGoogleLogin = () => {
        const customState = createCustomParams();
        const params = new URLSearchParams({
            client_id: googleConfig.client_id,
            redirect_uri: googleConfig.redirect_uri,
            response_type: googleConfig.response_type,
            scope: googleConfig.scope,
            nonce: googleConfig.nonce,
            state: customState
        });

        // 跳转到谷歌的 OAuth 授权页面
        window.location.href = `https://accounts.google.com/o/oauth2/v2/auth?${params.toString()}`;
    };
    const createCustomParams = () => {
        // 1. 准备你要传递的动态参数
        const customParams = {
            source: window.location.pathname,
            v: getParamVal('v')
        };
        // 为了防止数据在URL传输中出现格式问题，建议将其转为JSON字符串并进行URL编码
        return encodeURIComponent(JSON.stringify(customParams));
    };
    return { initAuth, userState };
};